import request from '@/api/request'

export default {

    getAccounts(params) {
        return request({
            url: '/account/getAccounts',
            method: 'get',
            params
        })
    },
    getAccountSize(params) {
        return request({
            url: '/account/getAccountSize',
            method: 'get',
            params
        })
    },

    fetchList(params) {
        return request({
            url: '/user/list',
            method: 'get',
            params
        })
    },

    createAccount(data) {
        return request({
            url: '/account/create',
            method: 'post',
            data : data
        })
    },

    updateUser(data) {
        return request({
            url: `/user/${data.id}`,
            method: 'put',
            data
        })
    },
    deleteUser(id) {
        return request({
            url: `/user/${id}`,
            method: 'delete'
        })
    },

    updateStatus(id, data) {
        return request({
            url: `/user/${id}/status`,
            method: 'patch',
            data
        })
    },

    resetPassword(id) {
        return request({
            url: `/user/${id}/password`,
            method: 'patch'
        })
    },

    assignRoles(id, roles) {
        return request({
            url: `/user/${id}/roles`,
            method: 'post',
            data: {roles}
        })
    },
}